import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { initBlock, resetBlock } from './EsimUpgradeBlockSlice';
import { prepareBlockAsync, OtpStepType, navigateEsimUpgradeBack } from './EsimUpgradeBlockAsyncThunk';
import { setMagicLinkParameters } from '../../../utilities/authentication/authenticationSlice';
import { clearStateHistoryAction } from '../../../utilities/stateHistory/stateHistorySlice';
import EsimBackButton from '../EsimQrCodeBlock/Partials/EsimBackButton/EsimBackButton';
import OtpPage from './Pages/OtpPage/OtpPage';
import ValidateOtpPage from './Pages/ValidateOtpPage/ValidateOtpPage';
import ReplaceSimToEsimPage from './Pages/ReplaceSimToEsimPage/ReplaceSimToEsimPage';
import SuccessPage from './Pages/SuccessPage/SuccessPage';
import ChooseSubscriberPage from './Pages/ChooseSubscriberPage/ChooseSubscriberPage';
import ErrorPage from './Pages/ErrorPage/ErrorPage';
import IdentityValidationPage from './Pages/IdentityValidationPage/IdentityValidationPage';
import WhatsAppSuccessPage from '../EsimQrCodeBlock/Pages/WhatsAppSuccessPage/WhatsAppSuccessPage';
import './EsimUpgradeBlock.scss';
import './Pages/SuccessPage/SuccessPage.scss';

const ESIM_AUTH_PAGES = ['otpPage', 'validateOtpPage', 'chooseSubscriberPage', 'securityOtpPage', 'identityValidationPage'];
const OTP_BACKGROUND_PAGES = ['otpPage', 'validateOtpPage', 'securityOtpPage'];

const EsimUpgradeBlock = (props) => {
    let currentView = null;
    const pageRef = useRef(props.page);
    pageRef.current = props.page;
    const hasOtpBackground = OTP_BACKGROUND_PAGES.includes(props.page);

    useEffect(() => {
        props.clearStateHistoryAction();
        if (typeof window !== 'undefined') {
            window.history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        props.resetBlock();
        props.initBlock({ esimUpgradeBlock: props.iContent });
        return () => {
            props.resetBlock();
        };
    }, []);

    useEffect(() => {
        if (props.authentication.isAuthenticateFinish) {
            props.prepareBlockAsync();
        }
    }, [props.authentication.isAuthenticateFinish]);

    useEffect(() => {
        const onPopState = () => {
            if (ESIM_AUTH_PAGES.includes(pageRef.current)) {
                props.navigateEsimUpgradeBack();
            }
        };
        window.addEventListener('popstate', onPopState);
        return () => window.removeEventListener('popstate', onPopState);
    }, []);

    switch (props.page) {
        case 'otpPage': currentView = <OtpPage />; break;
        case 'validateOtpPage': currentView = <ValidateOtpPage key='esim-otp-login' />; break;
        case 'replaceSimToEsimPage': currentView = <ReplaceSimToEsimPage />; break;
        case 'successPage': currentView = <SuccessPage />; break;
        case 'chooseSubscriberPage': currentView = <ChooseSubscriberPage />; break;
        case 'whatsAppSuccessPage': currentView = <WhatsAppSuccessPage />; break;
        case 'errorPage': currentView = <ErrorPage context={props.context} />; break;
        case 'identityValidationPage': currentView = <IdentityValidationPage />; break;
        case 'securityOtpPage': currentView = <ValidateOtpPage key='esim-otp-security' otpStepType={OtpStepType.SECURITY} />; break;
    }

    return (
        <>
            {hasOtpBackground && <div className='esim-upgrade-block__background' aria-hidden='true' />}
            <form
                noValidate
                id='esim-block'
                className={hasOtpBackground ? 'esim-upgrade-block--otp-background' : ''}
                onSubmit={handleSubmit}
            >
                {props.page && <EsimBackButton onClick={() => props.navigateEsimUpgradeBack()} />}
                {currentView}
            </form>
        </>
    );

    function handleSubmit(event) {
        event.preventDefault();
    }
};

const mapStateToProps = (state) => {
    return {
        page: state.esimUpgradeBlock.page,
        authentication: state.authentication,
    };
};

const mapDispatchToProps = {
    initBlock,
    resetBlock,
    prepareBlockAsync,
    showAppLoader,
    hideAppLoader,
    setMagicLinkParameters,
    clearStateHistoryAction,
    navigateEsimUpgradeBack,
};

export default connect(mapStateToProps, mapDispatchToProps)(EsimUpgradeBlock);
